import React from 'react';
import { Icon } from '@iconify/react';
import { useSimulation } from '../../contexts/SimulationContext';

const Navbar = ({ activeTab, onProfileClick }) => {
  const { project, allProjects, setProject } = useSimulation();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <header className="navbar">
      <div style={{ 
        maxWidth: '1400px', 
        width: '100%', 
        margin: '0 auto', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        padding: '0 30px'
      }}>
        {/* Left: Breadcrumbs */}
        <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
          <div style={{ color: 'var(--text-muted)', fontSize: '12px', fontWeight: 700, letterSpacing: '0.5px', display: 'flex', alignItems: 'center' }}>
            DASHBOARD <Icon icon="ion:chevron-forward-outline" width="12" style={{ margin: '0 8px' }} /> 
            <span style={{ color: 'var(--primary)' }}>{activeTab?.toUpperCase()}</span>
          </div>
        </div>

        {/* Center: Project Selection */}
        <div style={{ flex: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '16px' }}>
          <div style={{ fontSize: '11px', fontWeight: 800, color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>SELECT PROJECT:</div>
          <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
            <select 
              value={project?._id || ''} 
              onChange={(e) => {
                const selected = allProjects.find(p => p._id === e.target.value);
                setProject(selected);
              }}
              style={{
                background: 'white',
                color: 'var(--primary)',
                padding: '10px 48px 10px 20px',
                borderRadius: '16px',
                fontSize: '13px',
                fontWeight: 800,
                border: '1px solid var(--border-light)',
                cursor: 'pointer',
                outline: 'none',
                appearance: 'none',
                minWidth: '350px',
                boxShadow: '0 2px 8px rgba(128, 0, 0, 0.05)',
                transition: 'all 0.3s ease'
              }}
            >
              <option value="" disabled>Choose an active drive...</option>
              {allProjects.map(p => (
                <option key={p._id} value={p._id}>{p.name}</option>
              ))}
            </select>
            <Icon icon="ion:chevron-down-outline" width="12" style={{ position: 'absolute', right: '16px', pointerEvents: 'none', color: 'var(--primary)' }} />
          </div>
        </div>

        {/* Right: User Profile */}
        <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <div className="profile-pill" onClick={onProfileClick}>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: '14px', fontWeight: 700, color: 'var(--text-dark)' }}>{user.name || 'Master Admin'}</div>
              <div style={{ fontSize: '10px', color: 'var(--primary)', fontWeight: 800, letterSpacing: '1px' }}>{(user.description || user.designation || 'SUPERUSER').toUpperCase()}</div>
            </div>
            <div className="profile-avatar">
              <Icon icon="ion:person-circle-outline" width="26" />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
